import Button from '../../ui/button/index.vue';
import Breadcrumb from '../breadcrumb/index.vue';
import { useRouter } from 'vue-router';
import { computed, onMounted, ref, reactive } from 'vue';
import { CONIFG } from '@/config';
import { useStore } from 'vuex';
import { FEATURENAME, TASKTAB, ENV} from '@/enum/enum';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    Button,
    Breadcrumb
  },
  props: {
    userName: {
      type: String,
      default: '- - - ',
    },
    email: {
      type: String,
      default: 'aa@asus.com.tw',
    },
    btn: {
      type: Object,
      default() {
        return {
          text: 'Add Device',
        }
      },
    },
    sidemenu: {
      type: Array,
      default() {
        return [{
          link: '#',
          text: 'Dashboard',
          icon: 'ui-menu-dashboard',
        }, {
          link: '#',
          text: 'Device Management',
          icon: 'ui-menu-device',
        }]
      }
    }, //end: sidemenu
    sideInfo: {
      type: Array,
      default() {
        return [
          {link: FEATURENAME.TASK,
            text: 'Contact us',
            query: { tabId: TASKTAB.EXECUTED },  //有default預設的參數必須帶入
            icon: 'top-email_n',
            gtmId: '__taskManagement',
            sub: []
          }
        ]
      }
    }, //end: sidemenu
    time: {
      type: String,
      default: '2021/08/27 23:44:55',
    },
    btnIsShow: {
      type: Boolean,
      default: false
    },
    breadcrumb: {
      type: Array,
      default() {
        return [{ text: '第0層', link: 'ui' }, { text: '第0層', link: 'ui' }]
      }
    }, //end: breadcrumb
    isBack: {  //是否有back按鈕
      type: Boolean,
      default: true,
    },
    active: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore()
    const sideBar = ref();
    const { t } = useI18n();
    // const storeState = store.state;

    let state = reactive({
      all: false,
      isOpen: null,
      errorStyle: '',
      langSelectedIndex: 0,
    })


    const version = CONIFG.version;
    let privateActive = computed({
      get: () => props.active,
      set: (val) => {
        emit('update:active', val)
      }
    })
    const onClickMenu = (link, index , query = {}) => {
      // console.log(link, index , query ,router.currentRoute)
      // let fullPath = router.currentRoute.value.fullPath.split("/")
      // let path = fullPath.filter((element, index) => index < fullPath.length - 1 && element).join('/');
      router.push({ name: link , params : query }).catch(err => err);
      // privateActive = index;
      store.commit('setOpenSideBar', false)
      // router.push(`/${link}`);
    }
    const onClickSideInfo = (index) => {
      
      if(index == 2 ) {
        emit('onClickContact')
      }else{
        if(index == state.isOpen){
          state.isOpen = null;
        }else{
          state.isOpen = index
        }
      }
    }
    const onClickRefresh = () => {
      emit('onClickRefresh')
    }
    const onClickBack = () => {
      emit('onClickBack')
    }
    const onClickBtn = () => {
      emit('onClickBtn')
    }
    const onClickPrarmeter = () => {
      document.getElementById("Prarmeter").click();
    }
    const onClickLicense = () => {
      emit('onClickLicense');
    }
    const back = (e) => {//fix it to back to management page, not last page
      router.push(`/${props.breadcrumb[0].link}`);
      // router.back();
      // emit('onBack');
    }

    onMounted(() => {
      
      setHeightInit()

      windowResize()
      window.addEventListener("resize", windowResize);
    })

    const setHeightInit = () => {
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }


    const windowResize = async () => {
      setHeightInit()
      if( document.body.clientWidth <= 1024){ //window.innerHeight <= 1024 ||
        store.commit('setIsRWDBreakingPoint', true);
      }else {
        store.commit('setIsRWDBreakingPoint', false);
      }
    }

    store.watch((state) => (state.openSideBar), (newType) => { 
      newType ? sideBar.value.classList.add("sideBarActive") : sideBar.value.classList.remove("sideBarActive") 

    }, {
      deep: true
    })

    store.watch((state) => (state.isRWDBreakingPoint), (newType) => { 
      if(!newType){
        sideBar.value.classList.remove("sideBarActive") 
        store.commit('setOpenSideBar', false);
      }

    }, {
      deep: true
    })

    const maskClick = () => {
      store.commit('setOpenSideBar', false)
    }

    const onClickSideInfoList = (e, flag , index ) => {

      switch (flag) {
        case 'language':
          emit('onClickSideInfoList', e)
          break;
        case 'information':
          emit('onClickInfoList', index)
          break;
      }
    }

    const logout = () => {
      emit('onLogout');
    }


    store.watch(state => (state.langIsSelected), (val) => {
      let localIndex = props.sideInfo[0].sub.findIndex(obj => {
        return obj.val == val;
      })
      if(state.langSelectedIndex != localIndex) state.langSelectedIndex = localIndex
    })



    
    


    


    






    return {
      state,
      onClickMenu,
      onClickRefresh,
      onClickBack,
      onClickBtn,
      onClickPrarmeter,
      privateActive,
      onClickLicense,
      back,
      version,
      setHeightInit,
      sideBar,
      maskClick,
      windowResize,
      t,
      onClickSideInfo,
      onClickSideInfoList,
      logout
    }

  }
}


